import { ReactNode } from "react";
import styled from "styled-components";

interface Props {
    children: ReactNode;
    height?: number;
}

export const HeightText = styled.div`
    height: ${(props: Props) => `${props.height || 60}px`}; 
    transition: 0.2s ease-in;
    @media (max-width: 830px) {
        height: ${(props: Props) => `${props.height ? 100 : 70}px`};
        transition: 0.2s ease-in;
    }
    @media (max-width: 600px) {
        height: ${(props: Props) => `${props.height ? 50 : 40}px`}; 
        transition: 0.2s ease-in;
    }
    @media (max-width: 450px) {
        height: ${(props: Props) => `${props.height ? 80 : 40}px`}; 
        transition: 0.2s ease-in;
    }
`;
